//import usePageTracking from "./hooks/xUsePageTracking";
import "./App.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  ConfigurationContextProvider,
  TestsContextProvider,
  TargetsContextProvider,
  LocationContextProvider,
  ApplicationStateContextProvider,
} from "./contexts";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./components/footer/Footer.js";
import { Header } from "./components/header/Header.js";
import { Row, Col, Container } from "react-bootstrap";
import { Ad } from "./components/common";
//import { usePageTracking } from "./hooks";
import { PageTracking } from "./components/PageTracking";

export const App = () => {
  const location = useLocation();
  //  usePageTracking();

  /** Function: Should the ad column show?
   */
  const showAdColumn = () => {
    if (location.pathname.includes("testing")) {
      return false;
    }
    return true;
  };

  /** Rendering
   */
  return (
    <div className='App'>
      <ConfigurationContextProvider>
        <LocationContextProvider>
          <TestsContextProvider>
            <TargetsContextProvider>
              <ApplicationStateContextProvider>
                <PageTracking>
                  <Container fluid style={{ zIndex: "100" }}>
                    <Row className='justify-content-center'>
                      <Col className='px-2 col-auto' style={{ backgroundColor: "white" }}>
                        <div style={{ width: "1000px" }}>
                          <Header></Header>
                          <Row className='justify-content-between'>
                            <Col className={showAdColumn() ? "me-4" : "me-0"}>
                              {/* View provided by router. */}
                              <Outlet />
                            </Col>
                            {/* Ads */}
                            {showAdColumn() ? (
                              <Col className='col-auto'>
                                <Ad id='div-gpt-ad-sys-2'></Ad>
                                <Ad id='div-gpt-ad-sys-3'></Ad>
                              </Col>
                            ) : null}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Footer />
                    </Row>
                  </Container>
                  <div
                    id='div-gpt-ad-sys-0'
                    style={{
                      zIndex: "-100",
                      position: "absolute",
                      top: "0px",
                      left: "0px",
                    }}></div>
                </PageTracking>
              </ApplicationStateContextProvider>
            </TargetsContextProvider>
          </TestsContextProvider>
        </LocationContextProvider>
      </ConfigurationContextProvider>{" "}
    </div>
  );
};

export default App;
